"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeliverableGenerateReceiptWorklease = exports.isDeliverablesCreateZipFilesWorklease = exports.isDeliverableProperty = void 0;
const CreditAgreement_1 = require("../types/CreditAgreement");
const Deliverable_1 = require("../types/Deliverable");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isDeliverableProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: CreditAgreement_1.DomainEntity.DEPRECATED.DeliverablePropertySchema,
    typeguardName: 'isDeliverableProperty',
});
exports.isDeliverablesCreateZipFilesWorklease = (0, typeguardUtils_1.zodTypeGuard)(Deliverable_1.DeliverablesCreateZipFilesWorkleaseSchema);
exports.isDeliverableGenerateReceiptWorklease = (0, typeguardUtils_1.zodTypeGuard)(Deliverable_1.DeliverableGenerateReceiptWorkleaseSchema);
//# sourceMappingURL=deliverables.js.map